import { hidePrices as savePricesHidden, showPrices as savePricesShown } from "@/services/user/settings/pricesHiding/api";
import PostHog from "@/services/analytics/postHog";
import { useUser } from "@/composables/user/user";

export function usePriceVisibility() {
  const { user, arePricesVisible } = useUser();

  const hidePrices = () => {
    if (user.value === undefined) {
      throw new Error("DEV: User not logged in.");
    }
    user.value.showPrices = false;
    arePricesVisible.value = false;
    savePricesHidden();
    PostHog.trackEvent(PostHog.EventName.ShowPricesSettingsChange);
  };

  const showPrices = () => {
    if (user.value === undefined) {
      throw new Error("DEV: User not logged in.");
    }
    arePricesVisible.value = true;
    user.value.showPrices = false;
    savePricesShown();
    PostHog.trackEvent(PostHog.EventName.ShowPricesSettingsChange);
  };

  return {
    hidePrices,
    showPrices,
    arePricesVisible,
  };
}
